import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ScoreboardService} from "../../services/scoreboard.service";
import {ToastService} from "../../core/notifications/toast-service";
import {Scoreboard, UserScore} from "../../core/models/models";
import {ActivatedRoute} from "@angular/router";

import {NgxSkeletonLoaderModule} from "ngx-skeleton-loader";
import {UserRankComponent} from "../user-rank/user-rank.component";
import {ScoreTableComponent} from "../score-table/score-table.component";
import {SCOREBOARD_LEAGUES} from "../../core/models/leagues";

@Component({
  selector: 'app-scoreboard-table',
  standalone: true,
  imports: [
    NgxSkeletonLoaderModule,
    UserRankComponent,
    ScoreTableComponent
],
  templateUrl: './scoreboard-table.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './scoreboard-table.component.scss'
})
export class ScoreboardTableComponent implements OnInit {
  @Input()
  league = "overall";
  leagueDisplay: string = "";
  userScore: UserScore | undefined;
  scoreboard: Scoreboard | undefined;

  constructor(private scoreboardService: ScoreboardService,
              private toastService: ToastService,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.scoreboard = undefined;
      this.league = params['league']; // Get the current league parameter
      this.loadDataForLeague(); // Load data for the new league
    });
  }

  private loadDataForLeague() {
    switch (this.league) {
      case "overall":
        this.scoreboardService.getScoreboardOverall().then(
          (scoreboard) => this.scoreboard = scoreboard)
          .catch(() => this.toastService.showDanger("No scoreboards found"));
        this.leagueDisplay = ""

        this.scoreboardService.getUserScoreOverall()
          .then((userScore) => this.userScore = userScore)
          .catch(() => this.toastService.showDanger("User Score konnte nicht geladen werden!"))
        break;
      case "WWE":
      case "NXT":
      case "AEW":
        if (!SCOREBOARD_LEAGUES.includes(this.league)) {
          this.toastService.showDanger("Ungültige Liga")
          break;
        }
        this.scoreboardService.getScoreboardForLeague(this.league).then(
          (scoreboard) => this.scoreboard = scoreboard)
          .catch(() => this.toastService.showDanger("No scoreboards found"));
        this.leagueDisplay = this.league;

        this.scoreboardService.getUserScoreLeague(this.league)
          .then((userScore) => this.userScore = userScore)
          .catch(() => this.toastService.showDanger("User Score konnte nicht geladen werden!"))
        break;
      default:
        this.toastService.showDanger("Ungültige Liga")
        break;
    }
  }

  public loadMore() {
    if (this.scoreboard?.last_key == undefined) {
      this.toastService.showDanger("Keine weiteren Einträge vorhanden!")
      return;
    }

    const lastKey = this.scoreboard!.last_key!;
    switch (this.league) {
      case "overall":
        this.scoreboardService.getScoreboardOverallWithLastKey(lastKey).then(
          (scoreboard) => this.updateScoreboard(scoreboard))
          .catch(() => this.toastService.showDanger("No scoreboards found"));
        this.leagueDisplay = ""

        this.scoreboardService.getUserScoreOverall()
          .then((userScore) => this.userScore = userScore)
          .catch(() => this.toastService.showDanger("User Score konnte nicht geladen werden!"))
        break;
      case "WWE":
      case "NXT":
      case "AEW":
        if (!SCOREBOARD_LEAGUES.includes(this.league)) {
          this.toastService.showDanger("Ungültige Liga")
          break;
        }
        this.scoreboardService.getScoreboardForLeagueWithLastKey(this.league, lastKey).then(
          (scoreboard) => this.updateScoreboard(scoreboard))
          .catch(() => this.toastService.showDanger("No scoreboards found"));
        this.leagueDisplay = this.league;

        this.scoreboardService.getUserScoreLeague(this.league)
          .then((userScore) => this.userScore = userScore)
          .catch(() => this.toastService.showDanger("User Score konnte nicht geladen werden!"))
        break;
      default:
        this.toastService.showDanger("Ungültige Liga")
        break;
    }
  }

  private updateScoreboard(scoreboard: Scoreboard) {
    this.scoreboard!.scores = this.scoreboard!.scores.concat(scoreboard.scores);
    this.scoreboard!.last_key = scoreboard.last_key;
  }
}
